import { render, staticRenderFns } from "./heatmap.vue?vue&type=template&id=60b4736c"
import script from "./heatmap.vue?vue&type=script&lang=js"
export * from "./heatmap.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports